export const mergeStaticConfsIntoTplExtractedConfs = ({staticConfs, extractedConfs}) => {
    const finalConfs = [...extractedConfs]

    for(let c of staticConfs){
      // colId entries: merge-or-push (column identity). valuePath-only entries:
      // PATCH-ONLY — merge onto the extracted column whose data accessor
      // matches, and silently no-op when it doesn't exist. Lets transient
      // per-column overrides (e.g. the "Updating data…" migration state) target
      // a column by its exact valuePath without minting colIds — and without
      // ever pushing a phantom column.
      let matchingIdx = finalConfs.findIndex(cc =>
        c.colId ? cc.colId === c.colId : c.valuePath && cc.valuePath === c.valuePath
      );
            if(matchingIdx !== -1){ //match found so merge with the matching obj
        finalConfs[matchingIdx] = { ...finalConfs[matchingIdx], ...c }
      }else if(c.colId){ //no match found, so simply push into final confs
        finalConfs.push(c)
      }
    }

    return finalConfs
  }